import { Styled } from 'components/Styled'
import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  padding: 0px 72px;
  align-self: center;

  display: flex;
  flex-direction: column;
  gap: 30px;

  @media screen and (max-width: 767px) {
    padding: 0px 16px;
  }
`

export const Title = styled(Styled.H4)`
  @media screen and (max-width: 767px) {
    font-size: 16px;
    line-height: 20px;
  }
`
